export default {
    operacion: "list",
    pago: {
        
        tupa : null,
        "estado" : false,
        detalle : []
    }
}